module.exports = "<div class=form-group ng-if=\"isFilterDataExists( filterData )\"><a class=toogle-control ng-class=\"{ active: isFilterOpened }\" ng-click=changeOpenState()>{{::filterName }}</a><div ng-if=isFilterOpened><div class=clearfix ng-repeat=\"filterItem in ::filterData | orderBy: orderProperty\"><div class=checkbox><checkbox class=styled_checkbox checklist-model=filterModel checklist-value=filterItem.Value></checkbox><div class=checkbox_label>{{ ::filterItem.Key }}</div></div></div></div></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/directives/templates/results-dropdown-filter.tmpl.html
// module id = 549
// module chunks = 0